export default __webpack_public_path__ + "static/ut-screen-android-mobile-c47a359b96ca3d56d9a3f50c059b0d3c.webp";